import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";

@Component({
    selector: "app-gpd-pagination",
    imports: [CommonModule, DxButtonModule],
    templateUrl: "./gpd-pagination.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./gpd-pagination.component.css"]
})
export class GpdPaginationComponent {
  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Input() itemsPerPage: number = 0;
  @Input() totalItems: number = 0;
  @Input() showItemsInfo: boolean = true;

  @Output() onPageChange = new EventEmitter<number>();

  goToPage(page: number | string): void {
    if (typeof page === 'number' && page >= 1 && page <= this.totalPages) {
      this.onPageChange.emit(page);
    }
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.onPageChange.emit(this.currentPage - 1);
    }
  }

  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.onPageChange.emit(this.currentPage + 1);
    }
  }

  getPaginationPages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2; // pages shown on each side of current

    if (total <= 1) return [1];

    // Build the set of page numbers to always include:
    // first, last, and all pages within delta of current
    const rangeSet: number[] = [];
    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        rangeSet.push(i);
      }
    }

    // Walk the range and insert '...' (or the missing page if gap is exactly 1)
    const pages: (number | string)[] = [];
    let prev = 0;
    for (const page of rangeSet) {
      if (prev) {
        if (page - prev === 2) {
          pages.push(prev + 1); // show the single skipped page instead of '...'
        } else if (page - prev > 2) {
          pages.push('...');
        }
      }
      pages.push(page);
      prev = page;
    }

    return pages;
  }
}
